<template>
  <i :class="svgClass" v-on="$listeners"></i>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgClass () {
      if (this.className) {
        return 'svg-icon ' + this.className + ' fa fa-' + this.iconClass
      } else {
        return 'svg-icon fa fa-' + this.iconClass
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/FontAwesomeIcon/index.vue